// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CommitteeAttachment } from './committee-attachment';
import { CommitteeAttachmentEmail } from './committee-attachment-email';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CommitteeAttachmentEmailLink extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  attachmentId!: number;
  emailId!: number;
  attachment!: CommitteeAttachment;
  email!: CommitteeAttachmentEmail;
}

